import { GlobalState } from 'ha/types/store';
import { getUserId } from 'ha/modules/AuthLogic/selectors';

export const getChannelId = (s: GlobalState) =>
  getUserId(s) ? `u-${getUserId(s)}` : null;
